import { render, staticRenderFns } from "./StatisticsStatus.vue?vue&type=template&id=50826e3d&scoped=true"
import script from "./StatisticsStatus.vue?vue&type=script&lang=ts"
export * from "./StatisticsStatus.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsStatus.vue?vue&type=style&index=0&id=50826e3d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50826e3d",
  null
  
)

export default component.exports